// Night Owl theme definition for Monaco Editor
// Based on Sarah Drasner's Night Owl VS Code theme
// https://github.com/sdras/night-owl-vscode-theme

import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

export const nightOwlTheme: monaco.editor.IStandaloneThemeData = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: '', foreground: 'd6deeb', background: '011627' },
    { token: 'comment', foreground: '637777', fontStyle: 'italic' },
    { token: 'keyword', foreground: 'c792ea' },
    { token: 'string', foreground: 'ecc48d' },
    { token: 'string.escape', foreground: 'f78c6c' },
    { token: 'number', foreground: 'f78c6c' },
    { token: 'regexp', foreground: '80cbc4' },
    { token: 'type', foreground: 'ffcb8b' },
    { token: 'type.identifier', foreground: 'ffcb8b' },
    { token: 'type.default', foreground: '82aaff' },
    { token: 'function', foreground: '82aaff' },
    { token: 'variable', foreground: 'd6deeb' },
    { token: 'variable.predefined', foreground: 'addb67' },
    { token: 'variable.other.constant', foreground: 'f78c6c' },
    { token: 'constant', foreground: 'f78c6c' },
    { token: 'constant.numeric', foreground: 'f78c6c' },
    { token: 'tag', foreground: 'ef5350' },
    { token: 'attribute.name', foreground: 'c792ea' },
    { token: 'attribute.value', foreground: 'ecc48d' },
    { token: 'delimiter', foreground: 'd6deeb' },
    { token: 'delimiter.bracket', foreground: 'd6deeb' },
    { token: 'operator', foreground: 'c792ea' },
    { token: 'metatag', foreground: '21c7d8' },
    { token: 'metatag.content', foreground: '82aaff' },
    { token: 'annotation', foreground: 'ffcb8b' },
    { token: 'annotation.type', foreground: 'ffcb8b' },
  ],
  colors: {
    // Editor core
    'editor.background': '#011627',
    'editor.foreground': '#d6deeb',
    'editor.lineHighlightBackground': '#032440',
    'editor.selectionBackground': '#1b3d5e',
    'editor.selectionHighlightBackground': '#1b3d5e80',
    'editor.inactiveSelectionBackground': '#1b3d5e50',
    'editorCursor.foreground': '#80cbc4',
    'editorWhitespace.foreground': '#2b3e50',
    'editorIndentGuide.background': '#1d3b53',
    'editorIndentGuide.activeBackground': '#2a4d6e',

    // Line numbers & gutter
    'editorLineNumber.foreground': '#4b6b8a',
    'editorLineNumber.activeForeground': '#c792ea',
    'editorLineNumber.background': '#011627',
    'editorGutter.background': '#011627',
    'editorGutter.foldingArrowForeground': '#4b6b8a',
    'editorGutter.foldingHighightBackground': '#011627',

    // Find & brackets
    'editor.findMatchBackground': '#1b3d5e',
    'editor.findMatchHighlightBackground': '#1b3d5e50',
    'editorBracketMatch.background': '#1b3d5e',
    'editorBracketMatch.border': '#21c7d8',

    // Diagnostics
    'editorError.foreground': '#ef5350',
    'editorWarning.foreground': '#ffcb8b',
    'editorInfo.foreground': '#82aaff',
    'editorSuggestion.highlightForeground': '#c792ea',

    // Overview ruler / scrollbar
    'editorOverviewRuler.background': '#011627',
    'editorOverviewRuler.border': '#1d3b53',
    'scrollbarSlider.background': '#1d3b5380',
    'scrollbarSlider.hoverBackground': '#2a4d6e',
    'scrollbarSlider.activeBackground': '#4b6b8a',

    // Widgets
    'editorWidget.background': '#021d34',
    'editorWidget.border': '#1d3b53',
    'editorWidget.resizeBorder': '#1d3b53',
    'editorSuggestWidget.background': '#021d34',
    'editorSuggestWidget.border': '#1d3b53',
    'editorSuggestWidget.selectedBackground': '#1b3d5e',
    'editorSuggestWidget.highlightForeground': '#c792ea',

    // Peek view
    'peekViewEditor.background': '#011627',
    'peekViewResult.background': '#021d34',
    'peekViewTitle.background': '#021d34',

    // Minimap
    'minimap.background': '#011627',
    'minimapSlider.background': '#021d34',
    'minimapSlider.hoverBackground': '#032440',
    'minimapSlider.activeBackground': '#1b3d5e',
    'minimapGutter.addedBackground': '#011627',
    'minimapGutter.modifiedBackground': '#011627',
    'minimapGutter.deletedBackground': '#011627',
  },
};

export function registerNightOwlTheme(monacoRef?: any): void {
  // Use the provided monaco instance (from loader) or fall back to the direct import
  const api = monacoRef ?? monaco;
  api.editor.defineTheme('night-owl', nightOwlTheme);
}
